import { LoginService } from '@mango/authentication';
import { AlertService } from './alert/alert.service';
import { UserService } from './user/user.service';
import { DashboardService } from './dashboard/dashboard.service';
import { UserLoginHistoryService } from '@mango/authentication';

export const services = [
    LoginService,
    UserLoginHistoryService,
    AlertService,
    UserService,
    DashboardService
]